(() => {
  if (window.__hybridLandingScriptLoaded) return;
  window.__hybridLandingScriptLoaded = true;

  const initSlider = (root) => {
    if (!root || root.dataset.hybridSliderReady === 'true') return;

    const viewport = root.querySelector('[data-hybrid-slider-viewport]');
    const track = root.querySelector('[data-hybrid-slider-track]');
    const thumb = root.querySelector('[data-hybrid-slider-progress]');
    const previous = root.querySelector('[data-hybrid-slider-previous]');
    const next = root.querySelector('[data-hybrid-slider-next]');

    if (!viewport || !track) return;

    root.dataset.hybridSliderReady = 'true';

    const update = () => {
      const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      const progress = maxScroll === 0 ? 0 : Math.min(1, Math.max(0, viewport.scrollLeft / maxScroll));

      if (thumb) {
        const visibleRatio = Math.min(1, viewport.clientWidth / Math.max(viewport.scrollWidth, 1));
        const width = Math.max(visibleRatio * 100, 12);
        const travel = 100 - width;
        thumb.style.width = `${width}%`;
        thumb.style.transform = `translateX(${progress * travel / Math.max(width, .01) * 100}%)`;
      }

      if (previous) previous.disabled = maxScroll === 0 || viewport.scrollLeft <= 2;
      if (next) next.disabled = maxScroll === 0 || viewport.scrollLeft >= maxScroll - 2;
    };

    const getStep = () => {
      const firstSlide = track.firstElementChild;
      if (!firstSlide) return viewport.clientWidth;
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);
      return firstSlide.getBoundingClientRect().width + gap;
    };

    previous?.addEventListener('click', () => {
      viewport.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });

    next?.addEventListener('click', () => {
      viewport.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    viewport.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    requestAnimationFrame(update);
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-hybrid-slider]').forEach(initSlider);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
